import type { GuideDocument } from "@shared/guide";
import type { GuideEventLink } from "@shared/guideEvents";

/** Marks an event the week or weekend guide picked; standouts are the guide's "Don't miss" row. */
export interface GuidePickTag {
  guide: "week" | "weekend";
  standout: boolean;
}

/** The parts of an /api/newsletter-summaries row this needs. */
interface GuideSummaryLike {
  type: "week" | "weekend";
  guide?: GuideDocument | null;
  eventLinks?: GuideEventLink[];
}

/**
 * Event id → guide pick, from the saved guides. Structured guides list their picks;
 * older Markdown guides only have the events their bold names were matched to.
 * An event in both guides is tagged with the weekend guide, and a standout in either stays a standout.
 */
export function buildGuidePickMap(summaries: GuideSummaryLike[]): Map<string, GuidePickTag> {
  const map = new Map<string, GuidePickTag>();
  const add = (eventId: string, guide: "week" | "weekend", standout: boolean) => {
    const existing = map.get(eventId);
    map.set(eventId, {
      guide: existing?.guide === "weekend" ? "weekend" : guide,
      standout: standout || !!existing?.standout,
    });
  };

  for (const summary of summaries) {
    for (const day of summary.guide?.days ?? []) {
      for (const pick of day.picks) add(pick.eventId, summary.type, pick.standout);
    }
    for (const link of summary.eventLinks ?? []) add(link.event.id, summary.type, false);
  }
  return map;
}
